<template>
  <div>
    <div class="nav">
      <v-head></v-head>
    </div>
    <v-route1 :bindData="bindData0"></v-route1>
    <div class="container">
      <v-breadcrumb
        value1="首页"
        value2="互动交流"
        value3="行程规划"
        value4=""
        style="margin-left: 2.5%; margin-right: 2.5%"
      ></v-breadcrumb>
      <div class="content">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="40288a9d6e91c70a016e91cd7efb000e"
            >游玩</el-menu-item
          >
          <el-menu-item index="40288a9d6e91c70a016e91cd2d41000c"
            >住宿</el-menu-item
          >
          <el-menu-item index="40288a9d6e91c70a016e91cd018f000b"
            >美食</el-menu-item
          >
          <el-menu-item index="40288a9d6e91c70a016e91cdd286000f"
            >购物</el-menu-item
          >
          <el-menu-item index="40288a9d6e91c70a016e91ce074a0010"
            >娱乐</el-menu-item
          >
        </el-menu>
        <div class="all">
          <div class="map">
            <v-map
              :dataList="this.dataList"
              :selMarker="this.selMarker"
              @tableData="tableList"
            ></v-map>
            <v-right
              :dataList="this.dataList"
              @xcgh="closeMain"
              @popup="PopupClick"
              @search="search"
              @reload="research"
            ></v-right>
          </div>
          <div class="xc">
            <div class="top">
              <span style="margin-left: 2%">行程名称:</span>
              <el-input
                placeholder="请输入行程名称"
                v-model="xcName"
                style="width: 60%; margin-left: 2%"
              ></el-input>
            </div>
            <div class="top">
              <span style="margin-left: 2%">出发时间:</span>
              <el-date-picker
                v-model="value1"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="margin-left: 2%"
              >
              </el-date-picker>
            </div>
            <div class="center">
              <div @click="leftPoint">
                <img src="../../assets/img/left_font.png" alt="" />
              </div>
              <div
                style="
                  width: 60%;
                  height: 100%;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <el-button>第{{ num }}天</el-button>
                <el-button @click="addDay" type="primary">+</el-button>
              </div>
              <div @click="rightPoint">
                <img src="../../assets/img/right_font.png" alt="" />
              </div>
            </div>
            <div class="btm">
              <ul
                v-if="xcList != ''"
                v-for="(v, i) in xcList[this.num - 1]"
                :key="i"
                style="width: 100%;margin-top: 5%"
              >
                <el-time-picker
                  is-range
                  v-model="v.time"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  value-format="HH:mm:ss"
                  @change="changeTime(v)"
                  style="width:100%;border:none"
                >
                </el-time-picker>
                <li
                  style="
                    width: 100%;
                    height: 120px;
                    background-color: #fff;
                    margin-top:1%;
                  "
                  class="item"
                >
                  <div class="c_left">
                    <img
                      style="width: 80%; height: 75px"
                      :src="
                        'https://tour.i-lianjiang.cn/lianjiang_web_a' +
                        v.coverImageUrl
                      "
                      alt=""
                    />
                  </div>
                  <div class="c_right">
                    <span>{{ v.title }}</span>
                    <span>{{ v.summary | summary }}</span>
                    <span>地址:{{ v.address }}</span>
                    <span
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                      >价格:{{ v.price }}
                      <el-button type="danger" size="mini" @click="delXc(v)"
                        >移除行程</el-button
                      ></span
                    >
                  </div>
                </li>
              </ul>
            </div>
            <div class="atm">
              <div style="font-size:24px;margin-top:5%;width:140px">价格:<span style="color:red;font-size:24px">{{price}}</span>元</div>
              <el-button
                style="margin-left: 20%; margin-top: 5%;"
                type="primary"
                @click="save"
                >保存行程</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="isOpen" width="20%" title="景点详情">
      <el-form :data="tableData" v-if="tableData != null">
        <el-form-item prop="url">
          <img
            style="width: 50%"
            :src="
              'https://tour.i-lianjiang.cn/lianjiang_web_a' +
              tableData.coverImageUrl
            "
            alt=""
          />
        </el-form-item>
        <el-form-item style="height: 30px" label="名称">{{
          tableData.title
        }}</el-form-item>
        <el-form-item style="height: 30px" label="简介">{{
          tableData.summary | summary
        }}</el-form-item>
        <el-form-item style="height: 30px" label="地址">{{
          tableData.address
        }}</el-form-item>
        <el-form-item style="height: 30px" label="价格">{{
          tableData.price
        }}</el-form-item>
        <el-button style="margin-left: 70%" type="primary" @click="addXc"
          >添加行程</el-button
        >
      </el-form>
    </el-dialog>
    <v-footer></v-footer>
  </div>
</template>

<script>
import route from "../../components/common/route2";
import route1 from "../../components/common/route4";
import map from "../../components/map/map";
import right from "../../components/map/right";
import Axios from "axios";
export default {
  name: "list1",
  data() {
    return {
      activeIndex: "40288a9d6e91c70a016e91cd7efb000e",
      marketList: [],
      dataList: [],
      selMarker: [],
      price:0,
      xcName: null,
      tableData: null,
      isOpen: false,
      num: 1,
      value1: null,
      xcList: [[]],
      bindData0: [
        {
          name: "旅游攻略",
          url:
            "#/lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=40288a9d6e91c70a016e91c982fd0004",
          cid: "40288a9d6e91c70a016e91cf71920015",
        },
        {
          name: "游记分享",
          url:
            "#/yjfx?ljcode=yjfx&columnId=40288a9d6e91c70a016e91cff15c0016&rootColumnId=40288a9d6e91c70a016e91c982fd0004",
          cid: "40288a9d6e91c70a016e91cff15c0016",
        },
        {
          name: "行程规划",
          url:
            "#/xcgh?ljcode=xcgh&columnId=40288a9d6e91c70a016e91d01e460017&rootColumnId=40288a9d6e91c70a016e91c982fd0004",
          cid: "40288a9d6e91c70a016e91d01e460017",
        },
        {
          name: "旅游线路",
          url:
            "#/lyxl?ljcode=lyxl&columnId=40288a9d6e91c70a016e91d046210018&rootColumnId=40288a9d6e91c70a016e91c982fd0004",
          cid: "40288a9d6e91c70a016e91d046210018",
        },
      ],

      show: false,
      pageSize: 9,
      offset: 1,
      pagerInfo: {},
      datalist: null,
      ywqx: null,
    };
  },
  created() {
   console.log(this.$route.query,'query')
   if(this.$route.query.cid){
     var id = this.$route.query.cid
     let url = `${api}/api/cms/article/detail?articleId=${id}`;
     this.common.axios.get(url).then((res)=>{
        console.log(res,'res123')
        this.tableData = res.data.data
        this.tableData.day = 1
      this.xcList[0].push(this.tableData)
      })
      
   }
    this.getDate();
  },
  mounted() {
    this.getDate();
  },
  filters: {
    summary(v) {
      if (v.length > 20) {
        return v.slice(0, 20) + "...";
      } else if (v == "") {
        return "暂无简介";
      } else {
        return v;
      }
    },
  },
  methods: {
    changeTime(v){
      console.log(v,v.time,'v')
      v.startDate = v.time[0]
      v.endDate = v.time[1]
},
    research() {
      this.getDate();
    },
    search(v) {
      let url = `${api}/api/cms/article/list?poiFlag=1&isPage=0&columnId=${this.activeIndex}&title=${v}`;
      Axios.get(url).then((res) => {
        var mapList = [];
        var data = res.data.data;
        this.dataList = data;
        for (var i = 0; i < data.length; i++) {
          mapList.push([
            data[i].latlng.split(",")[0],
            data[i].latlng.split(",")[1],
          ]);
        }
      });
    },
    tableList(v) {
      this.isOpen = true;
      this.tableData = v;
      console.log(v, "table");
    },
    PopupClick(v) {
      //   this.isOpen = true;
      this.tableData = v;
      this.selMarker = [v.latlng.split(",")[0], v.latlng.split(",")[1]];
    },
    addXc() {
      console.log(this.tableData, "data1");
      this.tableData.day = this.num;
      this.xcList[this.num - 1].push(this.tableData);
      if(this.tableData.price==''){
        this.price = this.price
      }else {
        this.price = Number(this.price)+Number(this.tableData.price)
      }
      console.log(this.price)
      // v.day=this.num
      //   this.xcList[this.num-1].push(v)
    },
    save() {
      if (localStorage.getItem("id") == null) {
        this.$message.error("请先登录");
        return false;
      }
      if (this.xcName == null) {
        this.$message.error("请输入行程名称");
        return false;
      }
      if (this.value1 == null) {
        this.$message.error("请选择出发时间");
        return false;
      }
      if (this.xcList == "") {
        this.$message.error("请添加行程规划");
        return false;
      }
      var data = [];
      var data1 = [];
      var param = [];
      var sort =1
      //  console.log(this.xcList[0].length,'xc')
      //  return false
      for (var i = 0; i < this.xcList.length; i++) {
        data.push(this.xcList[i]);
      }
    
      for (var a = 0; a < data.length; a++) {
        for (var b = 0; b < data[a].length; b++) {
          console.log(data[a][b], "data1");
          data[a][b].articleId = data[a][b].id;
          data[a][b].articleName = data[a][b].title;
          data[a][b].columnId = data[a][b].columnInfo.id;
          data[a][b].columnName = data[a][b].columnInfo.name;
          data[a][b].sort = sort++;
          param.push(data[a][b]);
        }
      }
      //   console.log(param,'param')
      // return false
      var ids = localStorage.getItem("id");
      var param = {
        title: this.xcName,
        scheduleDate: this.value1,
        yuser: {
          id: ids,
        },
        schedulingDetailList: param,
      };

      let url = `${api}/api/scheduling/addScheduling`;
      // let url = `http://192.168.10.19:8080/lianjiang_web_i/api/scheduling/addScheduling`
      Axios.defaults.headers["Content-Type"] = "application/json";
      this.common.axios.post(url, param).then((res) => {
        if (res.data.msg == "保存成功") {
          this.$message.success("保存成功");
          this.reload();
        }
      });
      // Axios.get('https://tour.i-lianjiang.cn/lianjiang_web_i/api/scheduling/list?userid=8a9a9d8072e4724c0172f9b22e9b0000').then((res)=>{
      //     console.log(res)
      // })
    },
    reload() {
      this.num = 1;
      this.xcName = null;
      this.value1 = null;
      this.xcList = [[]];
    },
    leftPoint() {
      if (this.num - 1 == 0) {
        this.$message.error("已到行程规划第一天");
      } else {
        this.num = this.num - 1;
      }
    },
    rightPoint() {
      if (this.num == this.xcList.length) {
        this.$message.error("已到最后一天,请添加天数");
      } else {
        this.num = this.num + 1;
      }
    },
    closeMain(v) {
      console.log(v, "val");
      v.day = this.num;
      if(v.price==''){
        this.price = this.price
      }else{
        this.price=Number(this.price)+Number(v.price)
      }
     
      this.xcList[this.num - 1].push(v);
      console.log(this.xcList,'123');
    },
    delXc(v) {
      var data = this.xcList[this.num - 1];
      for (var i = 0; i < data.length; i++) {
        if (v.title == data[i].title) {
          data.splice(i, 1);
        }
      }
      this.xcList[this.num - 1] = data;
    },
    addDay() {
      this.num = this.num + 1;
      this.xcList.push([]);
    },
    async getDate() {
      await Axios.get(
        `${api}/api/cms/article/list?poiFlag=1&isPage=0&columnId=${this.activeIndex}`
      ).then((res) => {
        console.log(res.data.data, "res");
        var mapList = [];
        var data = res.data.data;
        this.dataList = data;
        console.log(this.dataList, "data");
        for (var i = 0; i < data.length; i++) {
          mapList.push([
            data[i].latlng.split(",")[0],
            data[i].latlng.split(",")[1],
          ]);
        }
        this.marketList = mapList;
      });
    },
    handleSelect(v) {
      Axios.get(
        `https://tour.i-lianjiang.cn/lianjiang_web_i/api/cms/article/list?poiFlag=1&isPage=0&columnId=${v}`
      ).then((res) => {
        console.log(res, "res");
        var mapList = [];
        var data = res.data.data;
        this.dataList = data;
        for (var i = 0; i < data.length; i++) {
          mapList.push([
            data[i].latlng.split(",")[0],
            data[i].latlng.split(",")[1],
          ]);
        }
        console.log(this.dataList, "data");
      });
    },
  },
  components: {
    "v-route": route,
    "v-route1": route1,
    "v-map": map,
    "v-right": right,
  },
};
</script>

<style lang="less" scoped>
.nav {
  position: relative;
  height: 350px;
  background: url("../../assets/img/廉江2.3.jpg");
  background-size: 100% 100%;
}
.route .route1[data-v-66436dcc] {
  margin: 0 !important;
}
.container {
  width: 100%;
}
.container_box {
  display: flex;
  flex-direction: column;
}
.content {
  width: 95%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  margin-left: 2.5%;
  .all {
    width: 100%;
    height: 70vh;
    display: flex;
    .map {
      position: relative;
      width: 80%;
      height: 100%;
      margin-bottom: 3%;
    }
    .xc {
      width: 20%;
      height: 100%;
      background-color: #f0f0f0;
      .top {
        width: 100%;
        height: 55px;
        display: flex;
        align-items: center;
      }
      .center {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .btm {
        width: 100%;
        height: 68%;
        display: flex;
        flex-direction: column;
        overflow: auto;
        background-color: #f0f0f0;
        .item {
          display: flex;
          flex-direction: row;
          .c_left {
            width: 30%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .c_right {
            width: 70%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
        }
      }
      .atm {
        width: 100%;
        height: 6%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }
  }
}
</style>
